import httpClient from '../utils/httpClient';

const API = '/course-attendance';

export const recordAttendance = async (data) => httpClient.post(API, data);
export const recordBulkAttendance = async (data) => httpClient.post(`${API}/bulk`, data);
export const getAttendanceByCourse = async (courseId, filters = {}) => {
  const params = new URLSearchParams();
  if (filters.date) params.append('date', filters.date);
  if (filters.month) params.append('month', filters.month);
  if (filters.year) params.append('year', filters.year);
  const qs = params.toString();
  return httpClient.get(qs ? `${API}/course/${courseId}?${qs}` : `${API}/course/${courseId}`);
};

/** Alias para vistas que referencian getByCourse */
export const getByCourse = getAttendanceByCourse;
export const getAttendanceByStudent = async (studentId, courseId) => {
  const url = courseId ? `${API}/student/${studentId}?courseId=${courseId}` : `${API}/student/${studentId}`;
  return httpClient.get(url);
};
export const getAttendanceRate = async (studentId, courseId) => httpClient.get(`${API}/rate/${studentId}/${courseId}`);
export const updateAttendance = async (id, data) => httpClient.put(`${API}/${id}`, data);
export const deleteAttendance = async (id) => httpClient.delete(`${API}/${id}`);
